module.exports = __webpack_public_path__ + "89842fa3d9a84cf54be5deffeefbc5db.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/walibi-holland-webfont.ttf
// module id = 30
// module chunks = 0